import Vue from "vue";
import App from "@/App.vue";
import axios from "axios";
import router from "@/router";
import store from "@/store";
import VueMeta from "vue-meta";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Toasted from "vue-toasted";
import Vuelidate from "vuelidate";
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "./utils/http-configs";
import "./utils/init-validation";
import "./utils/init-font-icons";
import "./utils/init-toast";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueScrollTo from "vue-scrollto";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import ZkTable from "vue-table-with-tree-grid-fold";
import OtpInput from "@bachdgvn/vue-otp-input";
import OtpAutofocus from "./directives/otp-autofocus";

Vue.use(Antd);
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "vue2-datepicker/locale/vi";

import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import InputText from "primevue/inputtext";
import Checkbox from "primevue/checkbox";
import MultiSelect from "primevue/multiselect";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";
import Tooltip from "primevue/tooltip";
import OrganizationChart from "primevue/organizationchart";
import TreeTable from "primevue/treetable";
import Tree from "primevue/tree";
import InputSwitch from "primevue/inputswitch";
import PickList from "primevue/picklist";
import "vue-loading-overlay/dist/vue-loading.css";
import "devextreme/dist/css/dx.light.css";
import "devextreme/dist/css/dx.common.css";

Vue.component("date-range-picker", DateRangePicker);
Vue.component("tooltip", Tooltip);
Vue.component("Button", Button);
Vue.component("DataTable", DataTable);
Vue.component("Column", Column);
Vue.component("ColumnGroup", ColumnGroup);
Vue.component("InputText", InputText);
Vue.component("Checkbox", Checkbox);
Vue.component("MultiSelect", MultiSelect);
Vue.component("Calendar", Calendar);
Vue.component("Dropdown", Dropdown);
Vue.component("OrganizationChart", OrganizationChart);
Vue.component("TreeTable", TreeTable);
Vue.component("Tree", Tree);
Vue.component("InputSwitch", InputSwitch);
Vue.component("PickList", PickList);
Vue.component("date-picker", DatePicker);
Vue.component("v-otp-input", OtpInput);
import Loading from "vue-loading-overlay";

Vue.directive("tooltip", Tooltip);
// v-otp-autofocus: tu focus o nhap OTP khi o do vao DOM (modal 1 buoc, modal nhieu buoc, trang tinh).
Vue.directive("otp-autofocus", OtpAutofocus);
Vue.use(Loading);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// Install Toasted
Vue.use(Toasted, {
  iconPack: "material",
});
// Install Vuelidate
Vue.use(Vuelidate);
Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);
Vue.use(VueScrollTo);
Vue.use(ZkTable);

Vue.config.productionTip = false;

export const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
axios.defaults.headers.post["Content-Type"] = "application/json";

const signalR = Vue.observable({ connect: null });

Object.defineProperty(Vue.prototype, "$signalHub", {
  get() {
    return signalR.connect;
  },

  set(value) {
    signalR.connect = value;
  },
});

Vue.prototype.$confirmCustom = {
  show(params) {
    store.commit('SET_SHOW_CONFIRM', params)
  },
}

window.vm = new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
